module.exports = __webpack_public_path__ + "fonts/Golos-Text_Medium.2bfa58c.woff2";